<template>
  <div class="code-wrapper">
    <div class="code-logo">
      <icon-font style="font-size: 170px;" type="gb-icon-yicangxinlogo" />
    </div>
    <div class="code-main">
      <div class="code-main-switch">
        <icon-font type="gb-icon-dingding1" @click="toDing" />
      </div>
      <div class="code-main-title">扫描登录</div>
      <div class="code-main-title__sub">请使用微信扫描二维码登录</div>
      <div class="code-main-pic">
        <img v-if="url"  width="270" :src="url" alt="">
        <img class="avatar_icon" width="32" height="32" src="@/assets/wx.png" alt="" />
      </div>
      <div class="code-main-btn">
        <a-button type="link" @click="_WxGetQRCode">
          <a-icon type="loading" v-if="loading"/>
          <a-icon type="sync" v-else />
          刷新
        </a-button>
      </div>
      <a-button type="link" class="code-main-back" @click="back">返回登录</a-button>
    </div>
  </div>
</template>

<script>
import { wxGetQRCode, wxLoginAutoRegister } from '@/api/sso/wxPlatform'

export default {
  props: {
    show: Boolean
  },
  data () {
    return {
      sceneId: null,
      url: null,
      loading: true,
      timer: null
    }
  },
  methods: {
    _WxGetQRCode () {
      this.loading = true
      wxGetQRCode({}).then(({ data: { sceneId, url } }) => {
        Object.assign(this, {
          sceneId,
          url
        })
        clearTimeout(this.timer)
        this._WxLoginAutoRegister()
      }).finally(() => {
        this.loading = false
      })
    },

    _WxLoginAutoRegister () {
      this.timer = setTimeout(() => {
        wxLoginAutoRegister({
          platformCode: 'SSO_SYS_USER',
          sceneId: this.sceneId
        }).then(({ data }) => {
          // 101 扫码登录成功;102 二维码已过期，请重新扫描登录;103新用户，请绑定手机号码,104还未获取到用户信息,继续请求
          switch (data.status * 1) {
            case 101:
              this.$emit('update:show', false)
              this.$emit('done', data)
              break
            case 102:
              this._WxGetQRCode()
              break
            case 103:
              this.$emit('close')
              this.$router.replace({
                path: '/login',
                query: {
                  openId: data.openId,
                  firstLogin: true
                }
              })
              this.$emit('update:show', false)
              break
            default:
              this._WxLoginAutoRegister()
              break
          }
        }).catch(() => {
          this._WxGetQRCode()
        })
      }, 1000)
    },

    toDing () {
      let width = 500
      let height = 500
      let left = (screen.width / 2) - (width / 2)
      let top = (screen.height / 2) - (height / 2) + 50
      window.open('//' + window.location.host.replace(/proxy\./g, '') + '/#/ding-talk-bind?bindDingTalk=2', '钉钉扫码登录', `height=${height}, width=${width},top=${top}, left=${left}, toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no`)
    },
    back () {
      this.$emit('to', 'login')
      this.$emit('update:show', false)
    }
  },
  watch: {
    show (val) {
      if (val) {
        this._WxGetQRCode()
      } else {
        clearTimeout(this.timer)
      }
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  }
}
</script>

<style lang="less" scoped>
@color: #007BFC;

.code-wrapper {
 position: fixed;
 left: 50%;
 top: 50%;
 transform: translate(-50%, -50%);
 text-align: center;
}
.code-logo {
  font-size: 120px;
  line-height: 1;
  color: @color;
}
.code-main {
  width: 540px;
  margin-top: -20px;
  padding-top: 48px;
  line-height: 1.5;
  background: #FFFFFF;
  box-shadow: 0px 8px 24px 5px rgba(212, 221, 230, 0.51);
  border-radius: 12px;
  padding-bottom: 40px;
  overflow: hidden;
  position: relative;
  &-switch {
    position: absolute;
    top: 0;
    right: 0;
    width: 100px;
    border: 50px transparent solid;
    border-top-color: #60ABFF;
    border-right-color: #60ABFF;
    .anticon {
      position: absolute;
      top: -50px;
      color: #fff;
      font-size: 45px;
      right: -45px;
      line-height: 80px;
      z-index: 5;
      cursor: pointer;
    }
  }
  &-title {
    color: #1C2D42;
    font-size: 24px;
    font-weight:bold;
    margin-bottom: 14px;
  }
  &-title__sub {
    color: #7F93A8;
    font-size: 14px;
    margin-bottom: 10px;
  }
  &-pic {
    width: 270px;
    height: 270px;
    position: relative;
    margin: 0 auto;
    .avatar_icon {
      position: absolute;
      left: 50%;
      top:50%;
      transform:translate(-50%, -50%);
      background-color: #fff;
      border-radius: 16px;
      z-index: 9999;
      display: block;
    }
  }
  &-btn{
    margin-bottom: 50px;
    & > button {
      line-height: 16px;
      height: auto;
    }
  }
}
</style>
